import axiosInstance from '../../../utils/axiosInstance';

import { ADVANCED_INVENTORY_ALL_OUTLETS } from '../constants';
import type { GetAllOutletsResponse } from './types';

export const getAllOutlets = async (
  filterDeletedOutlets = 'all'
): Promise<GetAllOutletsResponse> => {
  const { data } = await axiosInstance
    .get(ADVANCED_INVENTORY_ALL_OUTLETS, {
      params: { size: 500, status: filterDeletedOutlets },
    })
    .catch((error) => {
      if (error.response) {
        const eobj = new Error(error.response.data.errors);
        return Promise.reject(eobj);
      }
      return Promise.reject(new Error(error.message));
    });

  return data;
};
